
(function () {
  'use strict';

  function money(cents, format) {
    if (
      window.Shopify &&
      typeof Shopify.formatMoney === 'function'
    ) {
      return Shopify.formatMoney(
        cents,
        format || '${{amount}}'
      );
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency:
          (
            window.Shopify &&
            Shopify.currency &&
            Shopify.currency.active
          ) || 'USD'
      }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function init(section) {
    if (
      !section ||
      section.dataset.sfReady === 'true'
    ) {
      return;
    }

    section.dataset.sfReady = 'true';

    const variantsNode =
      section.querySelector(
        '[data-product-variants]'
      );

    if (!variantsNode) return;

    let variants = [];

    try {
      variants = JSON.parse(
        variantsNode.textContent
      );
    } catch (e) {
      console.error(
        'ShredFin variant JSON error:',
        e
      );

      return;
    }

    const form =
      section.querySelector(
        '[data-product-form]'
      );

    const variantInput =
      section.querySelector(
        '[data-variant-id]'
      );

    const price =
      section.querySelector(
        '[data-product-price]'
      );

    const compare =
      section.querySelector(
        '[data-compare-price]'
      );

    const addButton =
      section.querySelector(
        '[data-add-to-cart]'
      );

    const buyButton =
      section.querySelector(
        '[data-buy-now]'
      );

    const qtyInput =
      section.querySelector(
        '[data-quantity-input]'
      );

    const status =
      section.querySelector(
        '[data-product-status]'
      );

    const groups = [
      ...section.querySelectorAll(
        '[data-option-index]'
      )
    ];

    /* =========================
       SELECTED OPTIONS
    ========================== */

    function selectedOptions() {
      return groups.map((group) => {
        const button =
          group.querySelector(
            '.sf-main-product__variant-button.is-selected'
          );

        return button
          ? button.dataset.value
          : null;
      });
    }

    /* =========================
       FIND VARIANT
    ========================== */

    function findVariant(options) {
      return variants.find((variant) => {
        return variant.options.every(
          (option, index) =>
            option === options[index]
        );
      });
    }

    /* =========================
       CURRENT VARIANT
    ========================== */

    function currentVariant() {
      return (
        findVariant(selectedOptions()) ||
        variants.find(
          (variant) =>
            String(variant.id) ===
            String(
              variantInput &&
                variantInput.value
            )
        ) ||
        variants[0]
      );
    }

    /* =========================
       AVAILABILITY
    ========================== */

    function syncAvailability() {
      groups.forEach(
        (group, groupIndex) => {
          group
            .querySelectorAll(
              '[data-variant-option]'
            )
            .forEach((button) => {
              const candidate =
                selectedOptions();

              candidate[groupIndex] =
                button.dataset.value;

              const available =
                variants.some(
                  (variant) =>
                    variant.available &&
                    variant.options.every(
                      (option, index) =>
                        candidate[index] ==
                          null ||
                        option ===
                          candidate[index]
                    )
                );

              button.classList.toggle(
                'is-unavailable',
                !available
              );

              button.setAttribute(
                'aria-disabled',
                available
                  ? 'false'
                  : 'true'
              );
            });
        }
      );
    }

    /* =========================
       APPLY VARIANT
    ========================== */

    function applyVariant(variant) {
      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
        }

        if (buyButton) {
          buyButton.disabled = true;
        }

        return;
      }

      if (variantInput) {
        variantInput.value =
          variant.id;

        variantInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

      if (price) {
        price.textContent = money(
          variant.price,
          section.dataset.moneyFormat
        );
      }

      if (compare) {
        if (
          variant.compare_at_price &&
          variant.compare_at_price >
            variant.price
        ) {
          compare.hidden = false;

          compare.textContent = money(
            variant.compare_at_price,
            section.dataset.moneyFormat
          );
        } else {
          compare.hidden = true;
          compare.textContent = '';
        }
      }

      if (addButton) {
        addButton.disabled =
          !variant.available;

        addButton.textContent =
          variant.available
            ? section.dataset.addLabel ||
              'ADD TO CART'
            : section.dataset
                .soldOutLabel ||
              'SOLD OUT';
      }

      if (buyButton) {
        buyButton.disabled =
          !variant.available;
      }

      syncAvailability();

      try {
        const url =
          new URL(location.href);

        url.searchParams.set(
          'variant',
          variant.id
        );

        history.replaceState(
          {},
          '',
          url.toString()
        );
      } catch (e) {}

      document.dispatchEvent(
        new CustomEvent(
          'variant:change',
          {
            detail: {
              variant: variant
            }
          }
        )
      );
    }

    /* =========================
       VARIANT BUTTONS
    ========================== */

    section
      .querySelectorAll(
        '[data-variant-option]'
      )
      .forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            if (
              button.classList.contains(
                'is-unavailable'
              )
            ) {
              return;
            }

            const group =
              button.closest(
                '[data-option-index]'
              );

            if (!group) return;

            group
              .querySelectorAll(
                '[data-variant-option]'
              )
              .forEach((item) => {
                item.classList.remove(
                  'is-selected'
                );

                item.setAttribute(
                  'aria-pressed',
                  'false'
                );
              });

            button.classList.add(
              'is-selected'
            );

            button.setAttribute(
              'aria-pressed',
              'true'
            );

            applyVariant(
              findVariant(
                selectedOptions()
              )
            );
          }
        );
      });

    /* =========================
       QUANTITY
    ========================== */

    section
      .querySelectorAll(
        '[data-qty-minus], [data-qty-plus]'
      )
      .forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            if (!qtyInput) return;

            const min =
              parseInt(
                qtyInput.min || '1',
                10
              ) || 1;

            const max =
              qtyInput.max
                ? parseInt(
                    qtyInput.max,
                    10
                  )
                : Infinity;

            const step =
              parseInt(
                qtyInput.step || '1',
                10
              ) || 1;

            let value =
              parseInt(
                qtyInput.value ||
                  String(min),
                10
              ) || min;

            value +=
              button.hasAttribute(
                'data-qty-plus'
              )
                ? step
                : -step;

            qtyInput.value =
              Math.min(
                max,
                Math.max(
                  min,
                  value
                )
              );

            qtyInput.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );
          }
        );
      });

    /* =========================
       SHARE
    ========================== */

    section
      .querySelectorAll(
        '[data-share-product]'
      )
      .forEach((button) => {
        button.addEventListener(
          'click',
          async () => {
            const url =
              button.dataset
                .shareUrl ||
              location.href;

            try {
              if (navigator.share) {
                await navigator.share({
                  title:
                    document.title,
                  url: url
                });
              } else {
                await navigator.clipboard
                  .writeText(url);

                if (status) {
                  status.textContent =
                    'Product link copied.';

                  status.className =
                    'sf-main-product__status is-success';
                }
              }
            } catch (e) {}
          }
        );
      });

    /* =========================
       BUY NOW
    ========================== */

    if (
      buyButton &&
      form
    ) {
      buyButton.addEventListener(
        'click',
        () => {
          const variant =
            currentVariant();

          if (
            !variant ||
            !variant.available
          ) {
            return;
          }

          /*
            Don't reuse AJAX Add to Cart.
            Create normal Shopify form so
            redirect to checkout remains reliable.
          */
          const checkoutForm =
            document.createElement(
              'form'
            );

          checkoutForm.method =
            'POST';

          checkoutForm.action =
            '/cart/add';

          const id =
            document.createElement(
              'input'
            );

          id.type = 'hidden';
          id.name = 'id';
          id.value = variant.id;

          const quantity =
            document.createElement(
              'input'
            );

          quantity.type =
            'hidden';

          quantity.name =
            'quantity';

          quantity.value =
            qtyInput
              ? qtyInput.value || '1'
              : '1';

          const returnTo =
            document.createElement(
              'input'
            );

          returnTo.type =
            'hidden';

          returnTo.name =
            'return_to';

          returnTo.value =
            '/checkout';

          checkoutForm.appendChild(
            id
          );

          checkoutForm.appendChild(
            quantity
          );

          checkoutForm.appendChild(
            returnTo
          );

          document.body.appendChild(
            checkoutForm
          );

          checkoutForm.submit();
        }
      );
    }

    /* =========================
       ADD TO CART
       THEME-NATIVE DRAWER FLOW
    ========================== */

    if (form) {
      form.addEventListener(
        'submit',
        async (event) => {
          event.preventDefault();

          const variant =
            currentVariant();

          if (
            !variant ||
            !variant.available
          ) {
            return;
          }

          if (
            !addButton ||
            addButton.disabled
          ) {
            return;
          }

          const originalText =
            addButton.textContent;

          addButton.disabled =
            true;

          addButton.classList.add(
            'is-loading'
          );

          addButton.textContent =
            section.dataset
              .addingLabel ||
            'ADDING...';

          if (status) {
            status.textContent = '';

            status.className =
              'sf-main-product__status';
          }

          try {
            const formData =
              new FormData(form);

            /*
              Always force current variant/qty.
            */
            formData.set(
              'id',
              String(
                variant.id
              )
            );

            formData.set(
              'quantity',
              String(
                qtyInput
                  ? qtyInput.value ||
                    '1'
                  : '1'
              )
            );

            const cartDrawer =
              document.querySelector(
                'cart-drawer'
              );

            const cartNotification =
              document.querySelector(
                'cart-notification'
              );

            const renderer =
              cartDrawer ||
              cartNotification;

            /*
              CRITICAL:
              Same contract used by Dawn's
              product-form.js
            */
            if (
              renderer &&
              typeof renderer.getSectionsToRender ===
                'function'
            ) {
              const sections =
                renderer
                  .getSectionsToRender()
                  .map(
                    (sectionData) =>
                      sectionData.id
                  );

              formData.set(
                'sections',
                sections.join(',')
              );

              formData.set(
                'sections_url',
                window.location.pathname
              );
            }

            const cartAddUrl =
              (
                window.routes &&
                window.routes.cart_add_url
              ) ||
              '/cart/add.js';

            const response =
              await fetch(
                cartAddUrl,
                {
                  method: 'POST',
                  headers: {
                    Accept:
                      'application/json',
                    'X-Requested-With':
                      'XMLHttpRequest'
                  },
                  body:
                    formData
                }
              );

            const data =
              await response.json();

            if (
              !response.ok ||
              data.status
            ) {
              throw new Error(
                data.description ||
                  data.message ||
                  'Unable to add this item.'
              );
            }

            /*
              Native theme refresh
            */
            if (
              renderer &&
              typeof renderer.renderContents ===
                'function'
            ) {
              renderer.renderContents(
                data
              );
            } else {
              /*
                Theme without native renderer.
              */
              document.dispatchEvent(
                new CustomEvent(
                  'cart:refresh',
                  {
                    bubbles: true,
                    detail: {
                      product: data
                    }
                  }
                )
              );
            }

            /*
              IMPORTANT:
              Do NOT call cartDrawer.open()
              again here.

              Your CartDrawer.renderContents()
              already calls this.open().
              Calling it twice creates timing/
              empty-state problems.
            */

            addButton.textContent =
              section.dataset
                .addedLabel ||
              'ADDED TO CART';

            if (status) {
              status.textContent =
                'Added to cart.';

              status.className =
                'sf-main-product__status is-success';
            }

            setTimeout(() => {
              const activeVariant =
                currentVariant();

              addButton.classList.remove(
                'is-loading'
              );

              if (
                activeVariant &&
                activeVariant.available
              ) {
                addButton.disabled =
                  false;

                addButton.textContent =
                  section.dataset
                    .addLabel ||
                  originalText ||
                  'ADD TO CART';
              } else {
                addButton.disabled =
                  true;

                addButton.textContent =
                  section.dataset
                    .soldOutLabel ||
                  'SOLD OUT';
              }
            }, 1200);

          } catch (error) {
            console.error(
              'ShredFin Add to Cart:',
              error
            );

            if (status) {
              status.textContent =
                error.message ||
                'Could not add to cart.';

              status.className =
                'sf-main-product__status is-error';
            }

            addButton.classList.remove(
              'is-loading'
            );

            addButton.textContent =
              section.dataset
                .addLabel ||
              originalText ||
              'ADD TO CART';

            addButton.disabled =
              !variant.available;
          }
        }
      );
    }

    /* =========================
       INITIAL STATE
    ========================== */

    applyVariant(
      findVariant(
        selectedOptions()
      ) ||
      variants.find(
        (variant) =>
          String(variant.id) ===
          String(
            variantInput &&
              variantInput.value
          )
      ) ||
      variants[0]
    );
  }

  function boot(root) {
    (
      root || document
    )
      .querySelectorAll(
        '[data-sf-main-product]'
      )
      .forEach(init);
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => boot(document)
    );
  } else {
    boot(document);
  }

  document.addEventListener(
    'shopify:section:load',
    (event) =>
      boot(event.target)
  );
})();